import { FC, memo } from 'react';

import { Props as CoverProps } from '../Cover';
import ImageComponent from './ImageComponent';
import { isCoverSourceSame } from './utils';

interface Props extends Pick<CoverProps, 'coverSource' | 'coverResizeMode'> {
  onLoadEnd: () => void;
}

const CoverImage: FC<Props> = ({ coverSource, coverResizeMode, onLoadEnd }) => {
  return (
    <ImageComponent
      source={coverSource}
      resizeMode={coverResizeMode}
      onLoadEnd={onLoadEnd}
    />
  );
};

function areEqual(prevProps: Props, nextProps: Props) {
  return isCoverSourceSame(prevProps.coverSource, nextProps.coverSource);
}

export default memo(CoverImage, areEqual);
